import React, { useState } from 'react';
import NumberToPrice from '@/_components/NumberToPrice';
import { RightIcon } from '@/_assets/icon-components';
import {
  Box,
  Stack,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { IRedux } from '@/_store/types';

import { formatPhoneNumber } from '@/_utils/formatPhoneNumber';
import EditBottomSheet from './EditBottomSheet';
import { useTranslations } from 'next-intl';
import QRModal from './QRModal';
import { Link } from '@/i18n/navigation';

export default function User({
  balance,
}: {
  balance: { balance?: number; deposit?: number };
}) {
  const [isQR, setQR] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const t = useTranslations();

  const { user } = useSelector((state: IRedux) => state.auth);
  // const settings = useSelector((state: IRedux) => state.settings);

  const isCashbackQRVisible =
    user?.phone
  //   settings?.data?.data?.cashback_display_places?.includes('profile');

  const formattedPhoneNumber = formatPhoneNumber(user?.phone || '');

  const totalBalance = (balance?.balance || 0) + (balance?.deposit || 0);

  return (
    <Stack px={4} py={3} gap={3} bg='background.main'>
      {/* User Info Card */}
      <HStack
        w='full'
        bg='background.card'
        p={4}
        rounded={16}
        justifyContent='space-between'
        alignItems='center'
        cursor='pointer'
        onClick={() => setIsOpenModal(true)}
      >
        <VStack gap={0} alignItems='start'>
          <Text fontSize={20} fontWeight={600}>
            {user?.name}
          </Text>
          <Text fontSize='md' color='text.muted'>
            {formattedPhoneNumber}
          </Text>
        </VStack>
        <Box color='text.muted'>
          <RightIcon width='10' height='16' />
        </Box>
      </HStack>

      {/* Loyalty Card */}
      {isCashbackQRVisible && (
        <HStack
          w='full'
          bg='primary'
          p={4}
          rounded={16}
          justifyContent='space-between'
          alignItems='center'
          cursor='pointer'
          asChild
        >
          <Link href={`/loyalty`}>
            <VStack gap={0} alignItems='start'>
              <Text fontSize='lg' fontWeight={600} color='primary.text'>
                {t('loyalty_card')}
              </Text>
              <HStack gap={1}>
                <Text fontSize='md' color='primary.text' opacity={0.9}>
                  {t('total')}:
                </Text>
                <NumberToPrice
                  value={totalBalance}
                  textProps={{ fontSize: 'md', color: 'primary.text', fontWeight: 500 }}
                />
              </HStack>
            </VStack>
            <Box color='primary.text'>
              <RightIcon width='10' height='16' color='var(--primary-text)' />
            </Box>
          </Link>
        </HStack>
      )}

      <QRModal open={isQR} onOpenChange={(e) => setQR(e)} />
      <EditBottomSheet setIsOpen={setIsOpenModal} isOpen={isOpenModal} />
    </Stack>
  );
}
